/** Та же проверка, что на сервере: имя и пожелания до отправки заявки. */

const YO = '\u0451';
const YO_UP = '\u0401';
const VOWELS = new Set(`аеиоуыэюя${YO}aeiouy`.split(''));
const NAME_RE = new RegExp(
  `^[A-Za-zА-Яа-я${YO_UP}${YO}][A-Za-zА-Яа-я${YO_UP}${YO}\\-\\s']{0,39}$`,
);
const PROFANITY = [
  'хуй',
  'хуе',
  'хуе',
  'пизд',
  'еба',
  'еба',
  'ебл',
  'ебл',
  'бляд',
  'блять',
  'сука',
  'муда',
  'пидор',
  'пидар',
  'педик',
  'гандон',
  'залуп',
  'шлюх',
  'мраз',
];
const KEYBOARD = ['йцукен', 'фывап', 'ячсми', 'qwerty', 'asdfg', 'zxcvb'];

const fold = (text: string) =>
  text.toLowerCase().replace(new RegExp(YO, 'g'), 'е').replace(/[^a-zа-я]/g, '');

const hasProfanity = (text: string) => {
  const folded = fold(text);
  return PROFANITY.some((stem) => folded.includes(stem.replace(new RegExp(YO, 'g'), 'е')));
};

const hasVowel = (text: string) => text.toLowerCase().split('').some((ch) => VOWELS.has(ch));

const isKeyboardSmash = (text: string) => {
  const folded = fold(text);
  if (folded.length < 4) return false;
  return KEYBOARD.some((chunk) => folded.includes(chunk));
};

const tooRepetitive = (text: string) => {
  const letters = fold(text);
  if (letters.length < 3) return false;
  if (/(.)\1{2,}/.test(letters)) return true;
  const most = Math.max(...Array.from(new Set(letters)).map((ch) => letters.split(ch).length - 1));
  return most / letters.length > 0.6;
};

export const checkPersonName = (value: string): string | null => {
  const name = value.trim().replace(/\s+/g, ' ');
  if (name.length < 2) return 'Напишите имя, как к вам обращаться.';
  if (!NAME_RE.test(name)) return 'В имени оставьте буквы. Цифры и знаки лучше убрать.';
  if (hasProfanity(name) || isKeyboardSmash(name) || tooRepetitive(name) || !hasVowel(name)) {
    return 'Похоже, в имени случайный набор букв. Напишите имя спокойно, как в разговоре.';
  }
  return null;
};

export const checkWishes = (value: string): string | null => {
  const text = value.trim().replace(/\s+/g, ' ');
  if (!text) return null;
  if (text.length < 8) {
    return 'В пожеланиях пока мало текста. Напишите коротко, с чем нужна помощь.';
  }
  if (hasProfanity(text)) {
    return 'В пожеланиях есть слова, которые лучше заменить. Напишите спокойно, что нужно на занятии.';
  }
  if (isKeyboardSmash(text) || tooRepetitive(text) || !hasVowel(text)) {
    return 'В пожеланиях пока не видно смысла. Опишите тему или цель занятий.';
  }
  const words = text.split(/\s+/).filter(Boolean);
  if (words.length === 1 && fold(words[0]).length < 4) {
    return 'В пожеланиях пока не видно смысла. Опишите тему или цель занятий.';
  }
  return null;
};
